<template>
  <div>
    <b-form-group class="login-field-group">
      <label class="login-field-label">Mật khẩu mới</label>
      <b-form-input
        class="login-input form-control"
        type="password"
        v-model="$v.changePassword.newpassword.$model"
        :state="validateState('newpassword')"
        @keydown.space.prevent
        placeholder="Nhập mật khẩu mới"
      />
      <b-form-invalid-feedback>
        {{ getInvalidFeedback($v.changePassword, 'newpassword') }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group class="login-field-group">
      <label class="login-field-label">Xác thực mật khẩu mới</label>
      <b-form-input
        class="login-input form-control"
        type="password"
        @keydown.space.prevent
        v-model="$v.changePassword.confirmpassword.$model"
        :state="validateState('confirmpassword')"
        placeholder="Nhập lại mật khẩu mới"
      />
      <b-form-invalid-feedback>
        {{ getInvalidFeedback($v.changePassword, 'confirmpassword') }}
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>

  <script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    username: {
      required: true,
      type: String,
    },
  },
  mixins: [validationMixin],
  data() {
    return {
      changePassword: {
        newpassword: '',
        confirmpassword: '',
      },
      notMatch: true,
    };
  },
  validations: {
    changePassword: {
      newpassword: {
        required,
      },
      confirmpassword: {
        required,
        notMatch() {
          return this.notMatch;
        },
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.changePassword[name];
      return $dirty ? !$error : null;
    },
    catchAnyError() {
      this.notMatch = true;
      const newpassword = this.$v.changePassword.newpassword.$model;
      const confirmpassword = this.$v.changePassword.confirmpassword.$model;
      if (newpassword !== confirmpassword) {
        this.notMatch = false;
      }
      this.$v.changePassword.$touch();
      return this.$v.changePassword.$anyError;
    },
    getInvalidFeedback(validation, field) {
      if (!validation[field].$dirty) return '';

      if (field === 'newpassword' && !validation[field].required) {
        return 'Vui lòng nhập mật khẩu mới';
      }
      if (field === 'confirmpassword' && !validation[field].required) {
        return 'Vui lòng nhập lại mật khẩu';
      }
      if (!validation[field].notMatch) return 'Mật khẩu không khớp';
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
$login-brand-primary: #26a9b5;

.login-field-group {
  margin-bottom: 1rem;
}

.login-field-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.375rem;
}

.login-input {
  height: 44px;
  padding: 0 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font-size: 0.875rem;
  background-color: #fff;

  &:focus {
    border-color: $login-brand-primary;
    box-shadow: 0 0 0 3px rgba(38, 169, 181, 0.12);
  }
}
</style>
